$(document).ready(function () {
	$('.table-addresses .btn-del').click(function () {
		let $tr = $(this).closest('tr');
		let route = $(this).attr('href');
		let params = {_token: App.csrf};
		$.post(route, params, function (data) {
			$tr.remove();
		});

		return false;
	});
});